// eslint-disable-next-line no-unused-vars
import React, {useEffect} from 'react';
import {Link, Text} from 'react-aria-components';
import "./SyntheticUsersList.css"
import FullWidthLayout from "../../layouts/FullWidthLayout/FullWidthLayout";
import {LuKey, LuPencil, LuTrash2} from "react-icons/lu";
import api from "../../utils/api";
import DefaultButton from "../../components/Buttons/DefaultButton/DefaultButton";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import {Navigate} from "react-router-dom";
import LoadingLayout from "../../layouts/LoadingLayout/LoadingLayout";
import Notification from "../../components/Notification/Notification.js";

function SyntheticUsersList() {
    const [syntheticUsers, setSyntheticUsers] = React.useState(null)
    const [redirect, setRedirect] = React.useState(null)
    const [showDeleteConfirmation, setShowDeleteConfirmation] = React.useState(false)
    const [SyntheticUserToDelete, setSyntheticUserToDelete] = React.useState(null)

    function deleteSyntheticUser() {
        if(SyntheticUserToDelete === null) {
            return
        }
        api.deleteSyntheticUser(SyntheticUserToDelete.id).then(() => {
            api.listSyntheticUsers().then(data => {
                setSyntheticUsers(data)
            })
        })
        setShowDeleteConfirmation(false)
        setSyntheticUserToDelete(null)
    }

    function onCancelDelete() {
        setShowDeleteConfirmation(false)
        setSyntheticUserToDelete(null)
    }

    useEffect(() => {
        api.listSyntheticUsers().then(data => {
            setSyntheticUsers(data)
        })
    }, []);


    if (syntheticUsers === null || syntheticUsers === undefined) {
        return <LoadingLayout />
    }
    if (redirect) {
        return <Navigate to={redirect} />
    }

    let content = null;
    if (syntheticUsers.length === 0) {
        content = <Notification>No Users have been created yet. Get started by clicking the Create button above.</Notification>
    } else {
        const rows = syntheticUsers.map((db) => {
            const roles = []
            for (const role of db.roles) {
                roles.push(<div key={role.id} className="role pill">{role.name}</div>)
            }

            return <div key={db.id} className="synthetic-user-row" data-name={db.name}>
                <div className="synthetic-user-row-section name">{db.name}</div>
                <div className="synthetic-user-row-section roles">{roles}</div>
                <div className="synthetic-user-row-section actions">
                    <Link href={`/user/${db.id}`}><LuPencil /></Link>
                    <Link href={`/user/${db.id}/password`}><LuKey /></Link>
                    <LuTrash2 onClick={() => {
                        setSyntheticUserToDelete(db)
                        setShowDeleteConfirmation(true)
                    }} />
                </div>
            </div>
        })


        let deletionModal = null
        if (showDeleteConfirmation) {
            deletionModal = <ConfirmationModal
                title="Remove User"
                className="delete-user-modal"
                message="Are you sure you want to delete this User?"
                onConfirm={deleteSyntheticUser}
                onCancel={onCancelDelete}
            />
        }

        content = <>
            {deletionModal}
            <div className="synthetic-users-list">{rows}</div>
        </>
    }

    const actionButton = <>
        <DefaultButton text="Create User" onPress={() => {
            setRedirect(`/user/create`)
        }} />
    </>

    const description = <>
        These are synthetic users that can connect to proxies. Users are assigned to proxies through roles.
    </>
    return <FullWidthLayout
        title="Users"
        description={description}
        mainContent={content}
        actionButton={actionButton}
    />
}

export default SyntheticUsersList
